exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_menuIcon__2kpue{font-size:1.375rem;display:flex;align-items:center;text-decoration:none;color:#333}.style_menuIcon__2kpue:visited{color:#333}.style_menuIcon__2kpue:hover{opacity:.5}.style_container__3ABIN{display:flex;flex-direction:column;width:31.25rem}.style_menuContainer__2R1aB{overflow-y:auto;height:25rem}.style_filter__251fd{margin:0 1rem}", ""]);

// exports
exports.locals = {
	"menuIcon": "style_menuIcon__2kpue",
	"container": "style_container__3ABIN",
	"menuContainer": "style_menuContainer__2R1aB",
	"filter": "style_filter__251fd"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/form/InsertVariableButton/style.less
// module id = 1377
// module chunks = 8